<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g
              transform="translate(-752 -568) translate(728 544) translate(24 24) translate(4.333 4.333)"
            >
              <circle cx="21.667" cy="21.667" r="19.5" fill="#E1F5FE" />
              <path
                fill="#164194"
                d="M21.48 3.599c-9.86 0-17.882 8.02-17.882 17.881 0 9.86 8.023 17.882 17.882 17.882 9.86 0 17.882-8.022 17.882-17.882 0-9.86-8.023-17.881-17.882-17.881m0 39.361C9.635 42.96 0 33.325 0 21.48S9.635 0 21.48 0s21.48 9.635 21.48 21.48-9.635 21.48-21.48 21.48"
              />
              <path
                fill="#13A2E8"
                d="M21.48 11.588c-2.977 0-5.398 2.421-5.398 5.396h3.599c0-.99.806-1.797 1.799-1.797.993 0 1.8.806 1.8 1.797v.306c.001.47-.191.932-.53 1.268l-1.483 1.484c-1.012 1.006-1.59 2.399-1.586 3.821v2.11h3.598V23.86c0-.47.19-.932.528-1.27l1.484-1.482c1.012-1.004 1.589-2.4 1.587-3.821v-.302c0-2.975-2.421-5.396-5.398-5.396M19.69 31.372L23.27 31.372 23.27 27.773 19.69 27.773z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>